export default __webpack_public_path__ + "static/media/detail_big_16_3.ca839ce9.jpg";